(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xd-industrial-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-xd-slideshow]').forEach((slideshow) => {
      if (slideshow.dataset.xdReady === 'true') return;
      slideshow.dataset.xdReady = 'true';

      const slides = Array.from(slideshow.querySelectorAll('[data-xd-slide]'));
      const pages = Array.from(slideshow.querySelectorAll('[data-xd-page]'));
      const previous = slideshow.querySelector('[data-xd-previous]');
      const next = slideshow.querySelector('[data-xd-next]');
      const toggle = slideshow.querySelector('[data-xd-toggle]');
      const status = slideshow.querySelector('[data-xd-status]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const interval = Math.max(Number(slideshow.dataset.interval) || 5000, 3000);
      const autoplay = slideshow.dataset.autoplay === 'true';
      let activeIndex = 0;
      let timer;
      let manuallyPaused = !autoplay || reduceMotion.matches;

      const updateToggle = (paused) => {
        const label = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        toggle.textContent = label;
        toggle.setAttribute('aria-label', label);
      };

      const showSlide = (index, announce = true) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        pages.forEach((page, pageIndex) => {
          const active = pageIndex === activeIndex;
          page.classList.toggle('is-active', active);
          page.setAttribute('aria-current', String(active));
        });
        if (announce) status.textContent = pages[activeIndex].getAttribute('aria-label');
      };

      const stop = () => {
        window.clearInterval(timer);
        timer = undefined;
      };

      const start = () => {
        stop();
        if (manuallyPaused || document.hidden) return;
        timer = window.setInterval(() => showSlide(activeIndex + 1, false), interval);
      };

      const move = (step) => {
        showSlide(activeIndex + step);
        start();
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      pages.forEach((page) => page.addEventListener('click', () => {
        showSlide(Number(page.dataset.xdPage));
        start();
      }));
      toggle.addEventListener('click', () => {
        manuallyPaused = !manuallyPaused;
        updateToggle(manuallyPaused);
        if (manuallyPaused) stop();
        else start();
      });
      slideshow.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') move(-1);
        if (event.key === 'ArrowRight') move(1);
      });
      slideshow.addEventListener('mouseenter', stop);
      slideshow.addEventListener('mouseleave', start);
      slideshow.addEventListener('focusin', stop);
      slideshow.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', start);
      reduceMotion.addEventListener('change', () => {
        if (reduceMotion.matches) manuallyPaused = true;
        updateToggle(manuallyPaused);
        start();
      });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(slideshow)) stop();
      });

      updateToggle(manuallyPaused);
      showSlide(0, false);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
